import {DialogTypes, useDialogProvider} from './DialogProvider';

export const useDialog = <T>(type?: DialogTypes) => {
  const dialog = useDialogProvider<T>();
  const open = dialog.state?.type === type;

  const setOpen = (b: boolean) => {
    if (!type) return;
    if (!b) return dialog.onClose();
    dialog.setState({type: type} as never);
  };
  const update = (params: T) => {
    if (!type) return;
    return dialog.setState((prev) => {
      return {type: type, ...prev, ...params};
    });
  };

  return {
    ...dialog,
    open,
    setOpen,
    update,
  };
};
